export default __webpack_public_path__ + "static/media/bg.dc24fd7f.svg";